export const EXCLUDE_ICON_NAMES = ["icons_"];

export const GENERATION_RELEASE_DATES = [
  {
    name: "Generation-I",
    release: "1996",
  },
  {
    name: "Generation-II",
    release: "2000",
  },
  {
    name: "Generation-III",
    release: "2003",
  },
  {
    name: "Generation-IV",
    release: "2007",
  },
  {
    name: "Generation-V",
    release: "2010",
  },
  {
    name: "Generation-VI",
    release: "2013",
  },
  {
    name: "Generation-VII",
    release: "2017",
  },
  {
    name: "Generation-VIII",
    release: "2019",
  },
];

export const FAN_FAVORITES = [
  "Charizard",
  "Pikachu",
  "Onix",
  "MewTwo",
  "Eevee",
  "Gengar",
  "Mew",
  "Snorlax",
  "Lapras",
  "Gyarados",
];
